import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const SharedViewEmptyContent: FC = () => {
  const {
    canvasGraph: {
      emptyGraph: { emptySharedView: msgEmptySharedGraph },
    },
  } = useLocale();

  return (
    <>
      <p className='text-bold text-uppercase text-danger'>
        <i className='fa fa-exclamation-circle mr-2.5' />
        {msgEmptySharedGraph.title}
      </p>
      <p>{msgEmptySharedGraph.description}</p>
    </>
  );
};
